/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var DEFAULTS = {};
var _default = function _default() {
  var shape = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULTS;
  var sealed = Object.seal ? Object.seal(shape) : {};
  return sealed;
};
exports.default = _default;